/**
 * @generated SignedSource<<809baa69ee8d701658ef3dad9c41c359>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldInput_data$data = {
  readonly languages: ReadonlyArray<{
    readonly locale: Locale;
    readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_from">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_data">;
  readonly " $fragmentType": "TranslatableTextFieldInput_data";
};
export type TranslatableTextFieldInput_data$key = {
  readonly " $data"?: TranslatableTextFieldInput_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldInput_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextFieldInput_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locale",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranslatableTextFieldTranslateButton_from"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranslatableTextFieldTranslateButton_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4278972a3fbebd51567a7e8657a8679f";

export default node;
